<template>
  <input :value="modelValue" @input="update" :id="id" hidden />
</template>

<script>
export default {
  name: "CFTurnstileBypass",
  emits: ["update:modelValue"],
  props: {
    modelValue: String,
    id: {
      type: String,
      default: "turnstile_bypass",
    },
  },
  setup(props, { emit }) {
    const update = (e) => emit("update:modelValue", e?.target?.value);

    return {
      update,
    };
  },
};
</script>
